export const updateTickerItems = [
  "10 分钟前 · 星野MOMO 更新了《深夜电台 第 42 期》",
  "1 小时前 · 新增话题「夏日城市漫游」",
  "今天 · 直播专区上新「周三固定开播」主播 12 位",
  "昨天 · 福利资源合集更新 8 组",
  "本周 · 短视频精选榜完成刷新",
  "刚刚 · 桃子酱 上传《早餐铺的一天》",
  "2 小时前 · 老王影单 发布《被低估的冷门电影》",
];

export const entryBarItems = [
  { label: "短视频", icon: "ri-play-circle-line", desc: "3 分钟看完一条" },
  { label: "直播", icon: "ri-live-line", desc: "实时开播时间表" },
  { label: "福利资源", icon: "ri-gift-2-line", desc: "精选合集资源" },
  { label: "主播", icon: "ri-user-star-line", desc: "按领域找主播" },
  { label: "热门", icon: "ri-fire-line", desc: "近期高热内容" },
];

export const anchors = [
  {
    name: "星野MOMO",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20youthful%20female%20music%20streamer%20in%20a%20cozy%20warm-lit%20night%20studio%2C%20soft%20coral%20rim%20light%2C%20calm%20confident%20expression%2C%20shallow%20depth%20of%20field%2C%20clean%20warm%20cream%20background%2C%20magazine%20cover%20photography%2C%20high%20detail&width=600&height=800&seq=xl-host-01&orientation=portrait",
    tags: ["音乐现场", "深夜电台"],
    followers: "82.4 万",
    note: "每周三、六固定开播，深夜陪伴型内容",
  },
  {
    name: "阿哲Vlog",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20friendly%20male%20city%20vlogger%20in%20a%20warm%20minimal%20studio%2C%20golden%20window%20light%2C%20relaxed%20jacket%2C%20honest%20smile%2C%20soft%20shadows%2C%20clean%20warm%20neutral%20backdrop%2C%20magazine%20cover%20photography%2C%20high%20detail&width=600&height=800&seq=xl-host-02&orientation=portrait",
    tags: ["城市漫游", "生活记录"],
    followers: "46.1 万",
    note: "用镜头记录街角与老城，更新节奏稳定",
  },
  {
    name: "桃子酱",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20cheerful%20female%20food%20explorer%20in%20a%20warm%20cozy%20kitchen%20corner%2C%20amber%20soft%20light%2C%20appetizing%20ambience%2C%20gentle%20smile%2C%20shallow%20depth%20of%20field%2C%20clean%20warm%20cream%20background%2C%20magazine%20photography%2C%20high%20detail&width=600&height=800&seq=xl-host-03&orientation=portrait",
    tags: ["美食探店", "治愈系"],
    followers: "63.7 万",
    note: "从早市到夜市，专注本地小吃地图",
  },
  {
    name: "Leon学长",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20smart%20male%20tech%20reviewer%20in%20a%20warm%20minimal%20desk%20setup%2C%20soft%20amber%20task%20light%2C%20glasses%20and%20calm%20expression%2C%20clean%20warm%20neutral%20background%2C%20magazine%20cover%20photography%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=600&height=800&seq=xl-host-04&orientation=portrait",
    tags: ["知识科普", "数码测评"],
    followers: "39.2 万",
    note: "把复杂参数讲成大白话，选购不踩坑",
  },
  {
    name: "小鹿Lulu",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20an%20energetic%20female%20dancer%20in%20a%20warm%20retro-lit%20studio%2C%20golden%20practical%20lights%2C%20dynamic%20confident%20pose%2C%20clean%20warm%20cream%20backdrop%2C%20magazine%20cover%20photography%2C%20high%20detail&width=600&height=800&seq=xl-host-05&orientation=portrait",
    tags: ["舞蹈翻跳", "复古穿搭"],
    followers: "71.5 万",
    note: "翻跳热门编舞，顺带分享复古穿搭",
  },
  {
    name: "老王影单",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20thoughtful%20male%20film%20critic%20in%20a%20warm%20dim%20library%20corner%2C%20amber%20lamp%20glow%2C%20books%20and%20film%20reels%2C%20calm%20expression%2C%20clean%20warm%20brown%20background%2C%20magazine%20cover%20photography%2C%20high%20detail&width=600&height=800&seq=xl-host-06&orientation=portrait",
    tags: ["影视解读", "冷门佳片"],
    followers: "55.9 万",
    note: "只聊值得反复看的片子，长文式解读",
  },
];

export const topicWall = [
  { label: "深夜电台", size: "lg" },
  { label: "城市漫游", size: "md" },
  { label: "美食探店", size: "lg" },
  { label: "舞蹈翻跳", size: "md" },
  { label: "数码测评", size: "md" },
  { label: "影视解读", size: "lg" },
  { label: "治愈系", size: "sm" },
  { label: "复古穿搭", size: "md" },
  { label: "街头采访", size: "sm" },
  { label: "知识科普", size: "md" },
  { label: "助眠合集", size: "sm" },
  { label: "旅行vlog", size: "md" },
  { label: "露营日记", size: "sm" },
  { label: "手作教程", size: "md" },
  { label: "音乐现场", size: "lg" },
  { label: "宠物日常", size: "sm" },
  { label: "健身打卡", size: "sm" },
  { label: "摄影教学", size: "md" },
  { label: "脱口秀", size: "md" },
  { label: "游戏实况", size: "md" },
  { label: "读书分享", size: "sm" },
  { label: "咖啡拉花", size: "sm" },
  { label: "汉服日常", size: "sm" },
  { label: "素描速写", size: "sm" },
];

export const hotRanking = [
  {
    rank: 1,
    title: "深夜三点的城市电台｜第 42 期",
    cat: "直播",
    heat: "98.6",
    duration: "1 小时 46 分",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20still%20life%20of%20a%20late%20night%20radio%20studio%20microphone%20glowing%20with%20warm%20amber%20light%2C%20small%20speaker%20and%20vinyl%2C%20cinematic%20editorial%20cover%20art%2C%20clean%20warm%20dark%20background%2C%20high%20detail&width=240&height=240&seq=xl-hot-01&orientation=squarish",
  },
  {
    rank: 2,
    title: "一个人逛完了整座老城",
    cat: "短视频",
    heat: "94.2",
    duration: "12 分 08 秒",
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20cover%20art%20of%20an%20old%20city%20street%20at%20dusk%20with%20warm%20lanterns%20and%20empty%20alleys%2C%20cinematic%20editorial%20illustration%20style%2C%20clean%20warm%20tones%2C%20high%20detail&width=240&height=240&seq=xl-hot-02&orientation=squarish",
  },
  {
    rank: 3,
    title: "街头小吃全收录：从早市到夜市",
    cat: "短视频",
    heat: "91.7",
    duration: "18 分 32 秒",
    cover:
      "https://readdy.ai/api/search-image?query=Appetizing%20editorial%20cover%20of%20colorful%20street%20food%20stalls%20at%20a%20night%20market%2C%20warm%20golden%20light%2C%20steam%20and%20lanterns%2C%20cinematic%20still%20life%2C%20clean%20warm%20background%2C%20high%20detail&width=240&height=240&seq=xl-hot-03&orientation=squarish",
  },
  {
    rank: 4,
    title: "被低估的五部冷门电影",
    cat: "短视频",
    heat: "89.3",
    duration: "22 分 15 秒",
    cover:
      "https://readdy.ai/api/search-image?query=Retro%20film%20posters%20and%20a%20vintage%20projector%20glowing%20in%20a%20warm%20dark%20room%2C%20cinematic%20editorial%20cover%20art%2C%20amber%20highlights%2C%20clean%20warm%20background%2C%20high%20detail&width=240&height=240&seq=xl-hot-04&orientation=squarish",
  },
  {
    rank: 5,
    title: "零基础也能学会的夏日复古穿搭",
    cat: "短视频",
    heat: "87.9",
    duration: "9 分 41 秒",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20lay%20of%20warm%20summer%20retro%20outfits%20and%20vintage%20accessories%20on%20a%20cream%20surface%2C%20soft%20amber%20light%2C%20editorial%20fashion%20cover%2C%20clean%20warm%20background%2C%20high%20detail&width=240&height=240&seq=xl-hot-05&orientation=squarish",
  },
  {
    rank: 6,
    title: "数码选购避坑指南（2026 版）",
    cat: "短视频",
    heat: "85.4",
    duration: "15 分 02 秒",
    cover:
      "https://readdy.ai/api/search-image?query=Neat%20flat%20lay%20of%20modern%20gadgets%20and%20a%20notebook%20on%20a%20warm%20wooden%20desk%2C%20soft%20amber%20light%2C%20editorial%20tech%20cover%2C%20clean%20warm%20neutral%20background%2C%20high%20detail&width=240&height=240&seq=xl-hot-06&orientation=squarish",
  },
  {
    rank: 7,
    title: "一小时助眠钢琴现场合集",
    cat: "福利资源",
    heat: "83.1",
    duration: "合集 6 段",
    cover:
      "https://readdy.ai/api/search-image?query=Grand%20piano%20keys%20glowing%20under%20warm%20amber%20spotlight%20in%20a%20dark%20studio%2C%20cinematic%20music%20cover%20art%2C%20soft%20bokeh%2C%20clean%20warm%20background%2C%20high%20detail&width=240&height=240&seq=xl-hot-07&orientation=squarish",
  },
  {
    rank: 8,
    title: "露营新手第一次过夜实录",
    cat: "短视频",
    heat: "80.5",
    duration: "24 分 18 秒",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20camping%20tent%20glowing%20warmly%20at%20night%20under%20a%20starry%20sky%2C%20lanterns%20and%20folding%20chairs%2C%20cinematic%20editorial%20cover%20art%2C%20warm%20tones%2C%20high%20detail&width=240&height=240&seq=xl-hot-08&orientation=squarish",
  },
  {
    rank: 9,
    title: "周三固定开播：音乐现场连麦",
    cat: "直播",
    heat: "78.8",
    duration: "直播中",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20stage%20with%20two%20microphones%20and%20amber%20spotlights%20in%20a%20small%20live%20venue%2C%20editorial%20music%20cover%20art%2C%20clean%20warm%20background%2C%20high%20detail&width=240&height=240&seq=xl-hot-09&orientation=squarish",
  },
  {
    rank: 10,
    title: "手作教程合集：从零开始做一盏灯",
    cat: "福利资源",
    heat: "76.4",
    duration: "合集 4 段",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20wooden%20workbench%20with%20handmade%20lamp%20parts%20and%20tools%20under%20amber%20light%2C%20editorial%20craft%20cover%20art%2C%20clean%20warm%20background%2C%20high%20detail&width=240&height=240&seq=xl-hot-10&orientation=squarish",
  },
];

export const categoryBoards = [
  {
    key: "short",
    title: "短视频专区",
    subtitle: "3 分钟一条，通勤路上刚好刷完",
    icon: "ri-play-circle-line",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20collage%20of%20short%20video%20thumbnails%20feel%20with%20warm%20grain%20and%20coral%20accents%2C%20abstract%20play%20button%20motifs%2C%20clean%20warm%20cream%20background%2C%20magazine%20layout%20texture%2C%20high%20detail&width=800&height=500&seq=xl-board-01&orientation=landscape",
    items: ["城市漫游 · 老街清晨", "美食探店 · 早餐铺一天", "舞蹈翻跳 · 夏日编舞"],
  },
  {
    key: "live",
    title: "直播专区",
    subtitle: "开播时间一目了然，不用再蹲守",
    icon: "ri-live-line",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20live%20streaming%20studio%20with%20ring%20light%2C%20camera%20and%20soft%20coral%20glow%2C%20cozy%20broadcast%20set%2C%20clean%20warm%20background%2C%20editorial%20magazine%20photography%2C%20high%20detail&width=800&height=500&seq=xl-board-02&orientation=landscape",
    items: ["周三 20:00 · 星野MOMO 音乐现场", "周六 21:30 · 阿哲Vlog 城市夜游", "周日 19:00 · 老王影单 观影会"],
  },
  {
    key: "welfare",
    title: "福利资源专区",
    subtitle: "按主题整理好的合集，进来直接看",
    icon: "ri-gift-2-line",
    cover:
      "https://readdy.ai/api/search-image?query=Neatly%20arranged%20warm-toned%20resource%20collection%20of%20books%2C%20cards%20and%20gift%20boxes%20on%20a%20cream%20table%2C%20soft%20amber%20light%2C%20editorial%20magazine%20still%20life%2C%20clean%20background%2C%20high%20detail&width=800&height=500&seq=xl-board-03&orientation=landscape",
    items: ["助眠音乐合集（6 段）", "手作教程合集（4 段）", "周末片单合集（12 部）"],
  },
];

export const timelineItems = [
  { time: "10 分钟前", text: "星野MOMO 更新《深夜电台 第 42 期》，已加入音乐现场话题" },
  { time: "1 小时前", text: "新增话题「夏日城市漫游」，收录 18 条相关短视频" },
  { time: "今天 14:20", text: "直播专区上线「周三固定开播」主播 12 位" },
  { time: "昨天 21:05", text: "福利资源合集更新 8 组，覆盖助眠、手作与片单" },
  { time: "本周一", text: "短视频精选榜完成刷新，新增 24 条高热度内容" },
];

export const trustStats = [
  { value: "1,200+", label: "在册主播" },
  { value: "36", label: "内容分类" },
  { value: "每日", label: "更新频率" },
  { value: "7×24", label: "反馈通道" },
];

export const trustPoints = [
  {
    icon: "ri-layout-grid-line",
    title: "分类清晰，按图索骥",
    desc: "短视频、直播、福利资源各自成区，进入即可直奔目标，不用在信息流里反复翻找。",
  },
  {
    icon: "ri-time-line",
    title: "更新规律，来源可查",
    desc: "热门内容标注发布时间与所属主播，让你清楚每条内容从哪来、什么时候更新的。",
  },
  {
    icon: "ri-shield-check-line",
    title: "内容整理，反馈畅通",
    desc: "指南按主题做人工整理与归类，若发现不合适的内容，可通过页面反馈入口提交处理。",
  },
];

export const faqs = [
  {
    q: "小蓝视频主要有哪些内容分类？",
    a: "目前分为短视频、直播、福利资源三大专区，并在此基础上细分为城市漫游、美食探店、音乐现场、影视解读、知识科普等 36 个话题分类，方便按兴趣定位。",
  },
  {
    q: "怎么快速找到感兴趣的主播？",
    a: "可以先到「主播精选」浏览封面卡片，每张卡片都会标注主播的擅长领域与更新节奏；也可以直接点开「话题墙」，从感兴趣的话题反向找到对应主播。",
  },
  {
    q: "「福利资源」具体指什么？",
    a: "它指的是按主题人工整理好的合集类内容，例如助眠音乐合集、手作教程合集、周末片单合集等，特点是成组呈现、一次看完，而不是零散单条。",
  },
  {
    q: "内容多久更新一次？",
    a: "热门榜单与更新动态为每日刷新，直播时间去表按周维护，福利资源合集通常每周更新一批。具体时间可查看首屏顶部的更新条与「近期更新」板块。",
  },
  {
    q: "如何反馈或举报不合适的内容？",
    a: "页面顶部的反馈入口与页脚的「内容反馈」均可提交，我们会核对来源并按流程处理。本页为浏览指南，反馈通道为展示入口，正式开通后会同步说明。",
  },
];